import React from 'react';
import ReactDOM from 'react-dom';

// https://github.com/jaredreich/pell/blob/master/src/pell.js
// https://stackoverflow.com/a/11479435

class ContentEditable extends React.Component {

  shouldComponentUpdate(nextProps) {
    // console.log("ContentEditable shouldComponentUpdate")
    let domNode = ReactDOM.findDOMNode(this);
    return nextProps.html !== domNode.innerHTML;
  }
  
  emitChange = (e) => {
    // console.log("ContentEditable emitChange")
    let domNode = ReactDOM.findDOMNode(this);
    let html = domNode.innerHTML;
    if (this.props.onChange && html !== this.lastHtml) {
      this.props.onChange({
        target: {
          value: html
        }
      });
    }
    this.lastHtml = html;
  }

  handleClick = (e) => {
    e.stopPropagation()
    // console.log("handleClick")
    this.props.root.handleFocus(this.input)
  }

  handleBlur = (e) => {
    this.props.root.handleBlur(this.input)
    this.emitChange(e)
  }

  handleKeydown = (e) => {
    // console.log("handleKeydown")
    // this.props.root.handleKeydown(e)
  }
  
  render() {
    // onClick={this.handleClick}
    return <div 
      class="form-control news-input"
      onKeyUp={this.handleKeydown}
      onSelect={this.handleClick}      
      onFocus={this.handleClick}      
      onInput={this.emitChange} 
      onBlur={this.handleBlur}
      contentEditable
      ref={(ref) => this.input = ref} 
      dangerouslySetInnerHTML={{__html: this.props.html}}></div>;
  }

};

export default class Text extends React.Component {

  initialState = {
    content: ""
  }

  state = this.initialState

  componentWillMount() {
    let content = this.props.content
    this.setState({
      content: this.props.content
    })
  }

  handleChange = (e) => {
    // console.log("handleChange",e.target.value)
    let html = e.target.value
    if (html.indexOf("<a href=") != -1) {
      while(html.indexOf("<a href=") != -1) {
        html = html.replace("<a href=", "<a target='_blank' href=")
      }
    }
    this.props.el.content = html
    this.setState({content: html});   
    this.props.root.update() 
    // this.props.root.handleChangeContent(this.props.el,e.target.value)
  }

  render() {
    let editMode = this.props.mode == 'edit'
    let content = editMode ? this.state.content || this.props.content : this.props.content
    if (typeof content != "string") content = "";
    this.props.el.content = content
    return (
      <div class={"news-text mode-"+this.props.mode} onClick={e => e.stopPropagation()}>
        {this.props.mode == 'edit'
          ? <ContentEditable 
              html={content} 
              onChange={this.handleChange} 
              onSelect={this.props.onSelect}
              format={this.props.root.state.format}
              root={this.props.root}
            />
          : <div dangerouslySetInnerHTML={{__html: content}}></div>
        }
      </div>
    )
  }

}